export enum DeviceStatusEnum {
  NotVerified = 'not_verified',
  Verified = 'verified',
  VerifiedNotTrusted = 'verified_not_trusted'
}
